import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

// components
import Layout from "./Layout";
import Auth from "./Auth";

// pages
import Error from "../pages/error";
import Login from "../pages/login";

// context
import { useUserState } from "../context/UserContext";

export default function App() {
  // global
  var { isAuthenticated } = useUserState();
  var userOrgs = JSON.parse(localStorage.getItem("user_orgs"))

  return (
    <BrowserRouter>
      <Switch>
        <PublicRoute path="/connect/github/callback" component={Auth} />
        <PublicRoute path="/demo" component={Layout} />
        <Route
          exact
          path="/"
          render={() => <Redirect to="/login" />}
        />
        <Route
          exact
          path="/app"
          render={() => <Redirect to={`/app/tasks`} />}
        />
        <PrivateRoute path="/app" component={Layout} />
        <PublicRoute path="/login" component={Login} />
        <Route component={Error} />
      </Switch>
    </BrowserRouter>
  );

  // #######################################################################

  function PrivateRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={(props) =>
          isAuthenticated ? (
            React.createElement(component, props)
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: {
                  from: props.location,
                },
              }}
            />
          )
        }
      />
    );
  }

  function PublicRoute({ component, ...rest }) {
    var userOrgs = JSON.parse(localStorage.getItem("user_orgs"))
    return (
      <Route
        {...rest}
        render={(props) =>
          isAuthenticated && props.location.pathname !== "/demo" ? (
            <Redirect
              to={{
                pathname: "/app/tasks",
                search: `?org=${userOrgs[0].login}`
              }}
            />
          ) : (
            React.createElement(component, props)
          )
        }
      />
    );
  }
}
